import { HOTELS } from '@shared/helpers/routes';
import { Grid } from '@mui/material';
import { StyledButtonConfirmar } from '@shared/components/Buttons/styles';

const CloseButton = ({ history }) => {
  return (
    <Grid container sx={{ mt: 3 }}>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <StyledButtonConfirmar
          variant="contained"
          size="large"
          onClick={() => history.push(HOTELS)}
          align={'center'}
        >
          Cerrar
        </StyledButtonConfirmar>
      </Grid>
    </Grid>
  );
};

export default CloseButton;
